import React, {Suspense} from 'react';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import Header from '@di-shared/features/common/Header';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import MileageAgreement, {MileageAgreementLoading} from '@di-shared/features/mileage/agreement/MileageAgreement';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

interface MileageAgreementProps {
  vin: string;
}

function MileageAgreementPage({vin}: MileageAgreementProps) {
  const {t} = useInferableTranslation();
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T30195')}</h1>
      </Header>
      <Suspense fallback={<MileageAgreementLoading />}>
        <MileageAgreement vin={vin} />
      </Suspense>
    </div>
  );
}

export default MileageAgreementPage;
